import React from "react";
import { Select } from "antd";
const Option = Select.Option;

function SearchSelect(config) {
  return (
    <Select
      optionFilterProp="children"
      allowClear={false}
      maxTagCount={1}
      mode={config.mode || ""}
      placeholder={config.placeholder}
      defaultValue={config.defaultValue}
      onChange={value => {
        this.handleSelectChange(
          value,
          config.key
        );
      }}
      style={{ width: "75%", float: "right" }}
      showSearch
    >
      {config.options.map(ele => {
        return (
          <Option
            key={ele.value}
            value={ele.value}
          >
            {ele.label}
          </Option>
        );
      })}
    </Select>
  )
}

export default SearchSelect